import { ToastManagerRepository } from "@core/domain/repositories/toast-manager.repository.ts";
import type { ReportRouteGpsFilter } from "@report/domain/models/report-route-gps.ts";
import { ReportRouteGps } from "@report/domain/models/report-route-gps.ts";
import type { ReportRepository } from "@report/domain/repositories/report.repository";
import { reportTypes } from "@report/report-types.di";
import { inject, injectable } from "inversify";

@injectable()
export class ReportGetRouteGpsUseCase {
    constructor(
        @inject(reportTypes.repositories.ReportRepository)
        private readonly reportRepository: ReportRepository,
    ) {}

    async execute(
        reportRouteGpsFilter: ReportRouteGpsFilter,
    ): Promise<ReportRouteGps[]> {
        const reportRouteGpsResult =
            await this.reportRepository.fetchReportRouteGps(
                reportRouteGpsFilter,
            );

        if (reportRouteGpsResult.isErr()) {
            ToastManagerRepository.error(reportRouteGpsResult.error.message);
        }
        return reportRouteGpsResult.match(
            (reportRouteGps) => reportRouteGps,
            () => [],
        );
    }
}
